"use client";

import { z } from "zod";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { VersionsSchema } from "@/schemas/versions.schema";
import { Fragment, useEffect, useState } from "react";
import { getVersionsWithSubversions } from "@/services/versions.service";
import VersionsModal from "./VersionsModal";

interface Props {
  versions: z.infer<typeof VersionsSchema>[];
}

export default function VersionsTable(props: Props) {
  const [currentVersions, setCurrentVersions] = useState<
    z.infer<typeof VersionsSchema>[]
  >([]);


  useEffect(() => {
    const setInitialVersions = () => {
      setCurrentVersions(props.versions);
    };

    if (currentVersions.length === 0) {
      setInitialVersions();
    }
  }, [currentVersions, props.versions]);

  const refreshVersions = async () => {
    const versions = await getVersionsWithSubversions();
    setCurrentVersions(versions);
  }

  return (
    <div>
      <h1 className="text-xl font-bold text-black dark:text-white mb-2">
        Upgrade
      </h1>
      <VersionsModal updateData={refreshVersions} versions={currentVersions} onClose={() => refreshVersions()} />
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>#</TableHead>
            <TableHead>Title</TableHead>
            <TableHead>Updated At</TableHead>
            <TableHead>Created At</TableHead>
            <TableHead>Parent Version</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody key={'VersionsTable'}>
          {currentVersions.length > 0 ? (
            currentVersions?.map((domain, index) => (
              <Fragment key={index}>
                <TableRow key={domain.ID}>
                  <TableCell>{domain.ID}</TableCell>
                  <TableCell>{domain.Title}</TableCell>
                  <TableCell>{domain.UpdatedAt}</TableCell>
                  <TableCell>{domain.CreatedAt}</TableCell>
                </TableRow>
                {domain.SubVersions?.map((subversion, _index) => (
                  <TableRow key={subversion.ID}>
                    <TableCell>{subversion.ID}</TableCell>
                    <TableCell>{subversion.Title}</TableCell>
                    <TableCell>{subversion.UpdatedAt}</TableCell>
                    <TableCell>{subversion.CreatedAt}</TableCell>
                    <TableCell>{subversion.ParentVersionID}</TableCell>
                  </TableRow>
                ))}
              </ Fragment>
            ))
          ) : (
            <TableRow key={0}>
              <TableCell className="h-24 text-center">
                No results.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
